import { Card, CardHeader, CardContent, Typography, Link, Box, Grid } from '@mui/material';
import { School } from '@mui/icons-material';

function EducationCard({education}) {
  return (
    <Grid item xs={12} md={6}>
      <Card sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 300,
        m: 2,
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        },
        borderRadius: 2,
        overflow: 'hidden',
        position: 'relative'
      }}
      elevation={2}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: 'linear-gradient(90deg, #2196F3 0%, #1976D2 100%)'
          }}
        />
        <CardHeader
          avatar={
            <School color="primary" />
          }
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography 
                variant="h6" 
                component="div"
                sx={{
                  fontWeight: 500,
                  color: 'text.primary',
                  mb: 0.5
                }}
              >
                {education.university}
              </Typography>
              <Link 
                href={education.universityLink} 
                target="_blank" 
                underline="hover"
                sx={{ 
                  color: 'primary.main',
                  fontWeight: 500,
                  ml: 2,
                  '&:hover': {
                    color: 'primary.dark'
                  }
                }}
              >
                Visit University
              </Link>
            </Box>
          }
          sx={{ pb: 1 }}
        />
        <CardContent sx={{ 
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
          <Box>
            <Typography 
              variant="h6" 
              component="div" 
              gutterBottom 
              color="primary"
              sx={{
                fontSize: '1.1rem',
                fontWeight: 500,
                mb: 2
              }}
            >
              {education.degree}
            </Typography>
            <Typography 
              variant="subtitle1" 
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: 'text.secondary',
                fontWeight: 500
              }}
            >
              <strong>Major:</strong> {education.major}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2,
              pt: 2,
              borderTop: '1px solid',
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Started:</strong> {education.startYear}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Completed:</strong> {education.endYear}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default EducationCard;